// src/components/survey/survey-wrapper.tsx
'use client';

import { registerFDSRenderers, registerUniversalQuestions } from '@latitude-digital/survey-core';
// @ts-expect-error -- survey-core does not ship .d.ts yet (dts: false in tsup)
import { GlobalFooter, GlobalHeader } from '@latitude-digital/survey-core/layout';
import type { ReactNode } from 'react';

// 2. SurveyJS base styles
import 'survey-core/survey-core.min.css';
// 3. Ford UI component styles (Tailwind v3 utilities)
import '@ui/ford-ui-components/index.css';
// 4. Lincoln brand theme (CSS custom properties + @font-face)
import '@ui/fof-styles/dist/lincoln.css';
// 5. Survey-core FDS overrides (renderer styles, radio cards, etc.)
import '@latitude-digital/survey-core/styles';
// 6. Layout component styles (GlobalHeader/GlobalFooter)
import '@latitude-digital/survey-core/layout/index.css';

// Register FDS renderers and Lincoln question types — must run before any <Survey /> renders.
// Module-level execution ensures this happens exactly once.
registerFDSRenderers();
registerUniversalQuestions('lincoln', 'frontend');

interface SurveyWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper component for survey pages - provides consistent header/footer.
 * This allows survey routes to be at different URL paths while sharing layout.
 */
export function SurveyWrapper({ children }: SurveyWrapperProps) {
  console.log('process.env.NEXT_PUBLIC_GTB_ACCESS_KEY', process.env.NEXT_PUBLIC_GTB_ACCESS_KEY);
  return (
    <div className="min-h-screen flex flex-col">
      <GlobalHeader brand="Lincoln" />

      {/* Survey content */}
      <main className="container mx-auto px-4 py-8 flex-1">{children}</main>

      <GlobalFooter brand="Lincoln" oneTrustEnabled />
    </div>
  );
}
